'use client';
import { useState } from 'react';
import { TypeCourseProduct } from '@/core/generated-types';

export interface CourseNavigationPosition {
  partId: string;
  chapterId: string;
}

function useCourseNavigation(courseProduct: TypeCourseProduct) {
  const { courseParts } = courseProduct.fields;
  const [initialCoursePart] = courseParts;
  const [initialCourseChapter] = initialCoursePart.fields.chapters;

  const [navigationPosition, setNavigationPosition] = useState({
    partId: initialCoursePart.sys.id,
    chapterId: initialCourseChapter.sys.id,
  } as CourseNavigationPosition);

  const activePart = courseParts.find(
    (part) => part.sys.id === navigationPosition.partId,
  );

  const activeChapter = activePart?.fields?.chapters.find(
    (chapter) => chapter.sys.id === navigationPosition.chapterId,
  );
  const activePartIndex = activePart && courseParts.indexOf(activePart);

  function navigateToChapter(chapterId: string) {
    setNavigationPosition((prevState) => ({
      ...prevState,
      chapterId,
    }));
  }

  function navigateToPosition(partId: string, chapterId?: string) {
    const selectedCoursePart = courseProduct.fields.courseParts.find(
      (coursePart) => coursePart.sys.id === partId,
    );
    const firstChapterInSelectedCoursePart =
      selectedCoursePart?.fields?.chapters[0];
    const chapterToExpand =
      chapterId || firstChapterInSelectedCoursePart?.sys?.id;

    if (chapterToExpand) {
      setNavigationPosition((prevState) => ({
        ...prevState,
        chapterId: chapterToExpand,
        partId,
      }));
    } else {
      setNavigationPosition((prevState) => ({
        ...prevState,
        partId,
      }));
    }
  }

  return {
    navigationPosition,
    activeChapter,
    activePart,
    activePartIndex,
    navigateToPosition,
    navigateToChapter,
  };
}

export default useCourseNavigation;
